import { Deserializable } from '../protocols/deserializable';

export class VbLumpSumPaymentInstruction implements Deserializable {
  public id!: string;
  public desiredPaymentDate!: string;
  public paymentAmount!: number;

  public onDeserialize(): void {}
}
